class DropdownMenu extends HTMLElement {
  constructor() {
    'use strict';
    super();

    this.el = this;
    this.init();
  }

  init() {

    this.firstLevelItemsWithChildren = this.el.querySelector('.dropdown-menu__item-container');
    this.firstLevelItemsWithChildren.addEventListener('mouseleave', (event) => {
      this.el.classList.add("hidden")
      this.subitemOpener.classList.remove("dropdown-open")
      this.isMobile = false
    })

    // Handle opening of specific subitem from anywhere in the theme
    this.subitemOpener = this.el.parentElement.querySelector('[data-drawer-submenu-open="'+ this.dataset.href +'-'+ this.dataset.number +'"]');
    this.arrSubitemOpeners = this.el.parentElement.querySelectorAll('[data-drawer-submenu-open]');

    this.isMobile = false
    this.subitemOpener.addEventListener('touchstart',(e)=>{
      this.isMobile = true
    }, false);

    this.subitemOpener.addEventListener('click', this.toggleMenuItemFromTheme.bind(this));
    this.subitemOpener.addEventListener('mouseenter', (event) => {
      if (!this.isMobile) {
        this.el.classList.remove("hidden")
        this.subitemOpener.classList.add("dropdown-open")
      }
      this.isMobile = false
    });
    this.subitemOpener.addEventListener('mouseleave', (event) => {
      const buttonPosition = event.target.getBoundingClientRect()
      const bottomPosition = buttonPosition.bottom - 5

      if (bottomPosition > event.clientY) {
        this.el.classList.add("hidden")
        this.subitemOpener.classList.remove("dropdown-open")
      }
      this.isMobile = false
    });

    this.el.addEventListener('focusout', (event) => {
      if (!this.el.contains(event.relatedTarget)) {
        this.el.classList.add("hidden")
        this.subitemOpener.classList.remove("dropdown-open")
      }
      this.isMobile = false
    })
  }

  toggleMenuItemFromTheme(scope) {
    this.isMobile = false
    let target = false;
    const button = scope.currentTarget || scope;
    this.parent = button
    const url = button.getAttribute('data-drawer-submenu-open');

    if (this.firstLevelItemsWithChildren.getAttribute('data-href') === url) {
      target = this.firstLevelItemsWithChildren;
    }

    this.subitemOpener.classList.toggle("dropdown-open")
    this.el.classList.toggle("hidden")
  }

  toggleMenuItemFocus(scope) {
    let target = false;
    const button = scope.currentTarget || scope;
    const url = button.getAttribute('data-drawer-submenu-open');

    for (const input of this.firstLevelItemsWithChildren) {
      if (input.getAttribute('data-href') === url) {
        target = input;
        break;
      }
    }

    const firstA = target.querySelector("a")
    target.classList.toggle("hidden")
    firstA.focus()
  }

}

if (customElements.get('dropdown-menu') === undefined) {
  customElements.define('dropdown-menu', DropdownMenu);
}
